import { UserPlus, Pencil } from "lucide-react";
import { motion } from "framer-motion";

export default function FormHeader({ isEditing }) {
  return (
    <motion.div
      className="flex items-center gap-4"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25 }}
    >
      <div className={`p-2.5 rounded-xl ${isEditing ? "bg-indigo-100" : "bg-purple-100"}`}>
        {isEditing ? (
          <Pencil className="w-5 h-5 text-indigo-600" />
        ) : (
          <UserPlus className="w-5 h-5 text-purple-600" />
        )}
      </div>
      <div>
        <h3 className="text-xl font-bold text-gray-800">
          {isEditing ? "Edit Publisher" : "Add New Publisher"}
        </h3>
        <p className="text-xs text-gray-500 mt-0.5">
          {isEditing
            ? "Update the publisher's information below"
            : "Fill in the details to register a new publisher"}
        </p>
      </div>
    </motion.div>
  );
}
